module.exports = __webpack_public_path__ + "img/2021.329eaaf1.jpg";